<template>
    <v-dialog v-if="aboutDetailReport?.from === 'create_cs_po' && this.aboutDetailReport.typeDocument === 'cs'" v-model="dialog" max-width="700" v-resize="onResize" :persistent="loadingState? true: false">
        <v-card class="download-report-modal-card font-theme pa-6 text-center" style="border-radius: 20px;">
            <v-card-text class="py-4 text-center">
            <div class="text-h5 font-weight-bold grey--text text--darken-3 mb-2">
                Report Document
            </div>
                <h3 class=" mb-1 weekly-report-note-1">
                    กดปุ่มด้านล่างเพื่อดาวน์โหลดเอกสารรายงาน
                </h3>
            <div class="weekly-report-note-2">
            <span>
                หมายเหตุ: ข้อมูลที่แสดงเป็นรายงานซึ่งจัดทำและประมวลผลเป็นรายสัปดาห์
            </span>
        </div>
            </v-card-text>
            <v-card-actions class="justify-center pb-4">
            <v-btn
                color="#0B68D6"
                class="download-report-btn white--text text-capitalize elevation-0"
                @click="downloadReport()"
                :loading="loadingState"
                height="48"
                width="180"
                style="font-weight: 700; font-size: 18px; border-radius: 14px;"
            >
            <v-icon left size="20">mdi-download</v-icon>
                Download
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-else v-model="dialog" max-width="1044"  :persistent="loadingState">
            <v-card class="download-report-modal-card font-theme">
                <v-form lazy-validation ref="datePickerForm">
                    <v-row no-gutters class="standard-row download-report-header-modal px-10 px-sm-16 pt-10 text-center">
                        Report Document
                    </v-row>
                    <v-row no-gutters class="standard-row download-report-body-modal pl-10 pl-sm-16 pr-10 pr-sm-16 pr-md-10 pr-lg-0 pt-10 pb-10" align="center">
                        <v-col cols="12" sm="12" md="" lg="">
                            <v-row no-gutters class="standard-row" align="center">
                                <v-col cols="12" sm="4" md="4" lg="4">
                                    วันที่เริ่มต้น
                                </v-col>
                                <v-col cols="12" sm="8" md="" lg="8" class="pr-md-6">
                                    <v-menu offset-y v-model="startDateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field dense hide-details outlined clearable v-on="on" :value="startDateShow" height="53" color="black" background-color="white" @click:clear="selectedDate.start_date = null" :rules="[ v => !!v ]" required class="font-theme download-report-modal-text-date-picker"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th" v-model="selectedDate.start_date" @input="startDateMenu = false" :max="selectedDate?.end_date || new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" class="font-theme download-report-modal-date-picker"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="" lg="" class="mt-5 mt-md-0">
                            <v-row no-gutters class="standard-row" align="center">
                                <v-col cols="12" sm="4" md="4" lg="4">
                                    วันที่สิ้นสุด
                                </v-col>
                                <v-col cols="12" sm="8" md="" lg="8" class="pr-md-6">
                                    <v-menu offset-y v-model="endDateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field dense hide-details outlined clearable v-on="on" :value="endDateShow" height="53" color="black" background-color="white" @click:clear="selectedDate.end_date = null" :rules="[ v => !!v ]" required class="font-theme download-report-modal-text-date-picker"></v-text-field>
                                        </template>
                                        <v-date-picker color="#0B68D6" no-title show-current locale="th" v-model="selectedDate.end_date" @input="endDateMenu = false" :min="selectedDate?.start_date || ''" :max="new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)" class="font-theme download-report-modal-date-picker"></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="3" class="pl-lg-3 mt-10 mt-lg-0 pr-md-6 pr-lg-0" :class="windowSize.x < 1264? 'd-flex justify-center': ''">
                            <v-btn color="#0B68D6" class="white--text text-center" @click="downloadReport()" :loading="loadingState" height="53" width="193" style="font-weight: 700; font-size: 20px; border-radius: 20px; box-shadow: none;">
                                Download
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
    export default {
        data: () => ({
            dialog: false,
            endDateMenu: false,
            loadingState: false,
            startDateMenu: false,
            windowSize: { x: 0 },
            aboutDetailReport: null,
            selectedDate: { "start_date": null, "end_date": null }
        }),
        mounted () {
            this.onResize()
            EventBus.$on('openDownloadReportModal', this.openDialog)
        },
        beforeDestroy () {
            EventBus.$off('openDownloadReportModal')
        },
        computed: {
            startDateShow() {
                return MainFunction.shortDate(this.selectedDate.start_date)
            },
            endDateShow() {
                return MainFunction.shortDate(this.selectedDate.end_date)
            },
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            }
        },
        methods: {
            openDialog(params) {
                this.selectedDate      = { start_date: null, end_date: null },
                this.dialog            = true
                this.aboutDetailReport = params
                this.$refs.datePickerForm?.resetValidation()
            },
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            async downloadReport() {
                const isCreateCsPo = this.aboutDetailReport?.from === 'create_cs_po' && this.aboutDetailReport.typeDocument === 'cs';
                if (!isCreateCsPo && (!this.selectedDate.start_date || !this.selectedDate.end_date)) {
                    if (this.$refs.datePickerForm) {
                        this.$refs.datePickerForm.validate()
                    }
                    return this.alert('กรุณาเลือกวันที่ให้ครบถ้วน', 'Warning', 'info')
                }
                if (!this.aboutDetailReport.url) {
                    return
                }
                try {
                    this.loadingState = true
                    const { url, from, permission, inbox } = this.aboutDetailReport;
                    let queryParams = {};

                    if (from === 'all_document_cs_po') {
                        queryParams = {
                            start_date: this.selectedDate.start_date || null,
                            end_date: this.selectedDate.end_date || null,
                            tax_id: '0107544000094'
                        };
                    } else if (from === 'cut_petty_cash') {
                        queryParams = {
                            budget_type: permission,
                            start_date: this.selectedDate.start_date || null,
                            end_date: this.selectedDate.end_date || null
                        };
                    } else if (from === 'evalVendor') {
                        queryParams = {
                            start_date: this.selectedDate.start_date || null,
                            end_date: this.selectedDate.end_date || null,
                            inbox: inbox || null
                        };
                    } else if (from === 'summaryFinance') {
                        queryParams = {
                            doc_type: permission,
                            start_date: this.selectedDate.start_date || null,
                            end_date: this.selectedDate.end_date || null
                        };
                    } else if (isCreateCsPo && this.aboutDetailReport.typeDocument === 'cs') {
                        queryParams = {};
                    } else {
                        queryParams = {
                            start_date: this.selectedDate.start_date || null,
                            end_date: this.selectedDate.end_date || null,
                            inbox: permission || null,
                            tax_id: this.selectedBiz?.tax_id || null
                        };
                    }

                    const response = await this.axios.get(`${this.$api_url}${url}`, {
                        params: queryParams,
                        responseType: "blob"
                    });

                    const data = response.data;

                    if (data) {
                        let errorMessage = null
                        try {
                            errorMessage = JSON.parse(await data.text()).message
                        } catch (error) {
                            errorMessage = null
                        }
                        if (errorMessage === 'No have transaction during the selected period.' ||
                            errorMessage === 'No items found in the selected date range' ||
                            errorMessage === 'No vendor data available.') {
                            this.alert('ไม่พบรายการในช่วงวันที่เลือก', 'Fail', 'error')
                        } else if (errorMessage === 'inbox permission denied') {
                            this.alert('ไม่พบสิทธิ์ในการดาวน์โหลดรายงาน', 'Fail', 'error')
                        } else {
                            const link = document.createElement("a")
                            link.href = window.URL.createObjectURL(new Blob([data]))
                            let typeReport = ''
                            switch(from) {
                                case 'inbox':
                                    typeReport = `Inbox Report - ${permission?.toUpperCase() || 'undefined'} Permission`
                                    break;
                                case 'budget_inbox':
                                    typeReport = `Budget Inbox - ${permission?.toUpperCase() || 'undefined'} Permission`
                                    break;
                                case 'budget_cs_po':
                                    typeReport = `Budget Report - ${permission?.toUpperCase() || 'undefined'}`
                                    break;    
                                case 'inbox_cs_po':
                                    typeReport = `Inbox Report - ${permission?.toUpperCase() || 'InboxCstoPo'} Permission`
                                    break;
                                case 'add_item':
                                    typeReport = `Item Report`
                                    break;
                                case 'add_vendor':
                                    typeReport = `Vendor Report`
                                    break;
                                case 'dashboard_memo':
                                    typeReport = `Memo Report`
                                    break;
                                case 'all_document_cs_po':
                                    typeReport = `All Document CS to PO Report`
                                    break;
                                case 'create_cs_po':
                                    typeReport = `Create CS to PO Report`
                                    break;
                                case 'cut_petty_cash':
                                    typeReport = `Petty Cash Report - ${permission?.toUpperCase() || 'ALL'}`
                                    break;
                                case 'evalVendor':
                                    typeReport = `Item evalVendor`
                                    break;
                                case 'summaryFinance': {
                                    if (permission === "ใบยืมเงินทดรอง" || permission === "ใบคืนเงินทดรอง") {
                                        typeReport = `Summary Finance Report ${permission}`
                                    } else {
                                        typeReport = `Summary Finance Report`
                                    }
                                    break; 
                                }
                            }
                            const fileName = isCreateCsPo
                            ? `${typeReport} - CS.xlsx`
                            : `${typeReport} - SO - Date ${MainFunction.fullDateEN(this.selectedDate.start_date)} to ${MainFunction.fullDateEN(this.selectedDate.end_date)}.xlsx`; 
                            link.setAttribute("download", fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success')
                        }
                    } else {
                        this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    console.log(error);
                    this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                } finally {
                    this.loadingState = false
                }
            },
            alert(title = '', text = 'Warning', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        },
    }
</script>

<style>
    .download-report-modal-card {
        background-color: #F4F4F4 !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        border-radius: 20px !important;
    }

    .download-report-header-modal {
        font-weight: 700;
        font-size: 32px;
    }

    .download-report-body-modal {
        font-weight: 700;
        font-size: 20px;
    }

    .download-report-modal-text-date-picker {
        border-radius: 20px !important;
    }

    .theme--light.download-report-modal-text-date-picker:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        color: #BDBDBD !important;
    }

    .download-report-modal-date-picker .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 16px !important;
    }

    .download-report-modal-date-picker .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .download-report-modal-text-date-picker .v-input__control .v-input__slot .v-text-field__slot input {
        margin: 0px 4px;
        font-size: 20px;
    }

    .download-report-modal-text-date-picker .v-input__control .v-input__slot .v-input__append-inner {
        padding-top: 14.5px;
    }

    .download-report-btn >>> .v-btn__content {
        transition: all 0.2s ease;
    }

    .download-report-btn:hover {
        background: #0959B8 !important;
        box-shadow: 0 6px 14px rgba(11, 104, 214, 0.25) !important;
        transform: translateY(-1px);
    }

    .weekly-report-note-1 {
        display: inline-flex;
        align-items: center;
        padding: 7px 14px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
    }

    .weekly-report-note-2 {
        display: inline-flex;
        align-items: center;
        padding: 7px 14px;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 600;
    }
</style>